/**
 * Explicit Syntax Parser — re-exported from @lokascript/intent
 */

export {
  STRUCTURAL_ROLES,
  parseExplicit,
  isExplicitSyntax,
  parseCompound,
  parseDocument,
  isCompoundSyntax,
  isDocumentSyntax,
} from '@lokascript/intent';
